import React from "react";
import { injectIntl } from "react-intl";
import { AuthWrapper } from "../../../../components/AuthWrapper/AuthWrapper";
import { ButtonComponent } from "../../../../components/Controls/Button/Button";
import history from "../../../../routes/history";
import { confirmedResetPassword, logo } from "../../../../utils/images";
import "./resetPasswordSuccess.scss"

const AgenciesResetPasswordSuccessMsg = ({ intl: { messages }, inDialog }) => {
  const renderContent = () => {
    return (
      <div className="text-center reset-success-msg-wrapper">
        {!inDialog && (
          <div className="">
            <img src={logo} alt="logo" width={150} className="mt-4" />
          </div>
        )}
        <img
          src={confirmedResetPassword}
          alt="password reseted successfully"
          width={75}
          className="my-5"
        />
        <p className="h4">{messages.auth.resetPasswordSuccess}</p>
        <ButtonComponent
          content={messages.auth.login}
          variant="contained"
          classes="mx-2 px-5 my-3 form-submit-btn"
          handleClick={() => history.push("/agencies/login")}
          color="primary"
        />
      </div>
    );
  };
  return inDialog ? renderContent() : <AuthWrapper content={renderContent()} />;
};

export default injectIntl(AgenciesResetPasswordSuccessMsg);
